import useSetupContexts from './useSetupContexts';

export default function useGlobalStateReady() {
  const setupContexts = useSetupContexts();
  return !setupContexts.some(({ ready }) => !ready);
}
